import { useEffect } from "react";
import "@/App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import Accompagnements from "./pages/Accompagnements";

function App() {
  return (
    <div className="App">
      <HashRouter>
        <Routes>
          <Route path="/" element={<Accompagnements />} />
        </Routes>
      </HashRouter>
    </div>
  );
}

export default App;
